/* eslint-disable no-undef */
/* eslint-disable no-useless-return */
/* eslint-disable import/prefer-default-export */
import $ from 'jquery';

export class Recaptcha {
  constructor(inputsClass) {
    this.inputs = document.querySelectorAll(inputsClass);
    this.inputClass = inputsClass;

    this.isApplied = false;
    this.badge = '<div id="googleRecaptchaBadge"></div>';
  }

  prepareCaptcha() {
    if (!this.inputs.length) {
      return;
    }
    const self = this;

    const recaptchaScript = document.createElement('script');
    recaptchaScript.onload = () => {
      grecaptcha.ready(() => {
        document.querySelector('body').insertAdjacentHTML('beforeend', this.badge);
        const clientId = grecaptcha.render('googleRecaptchaBadge', {
          sitekey: '6LfY2KIUAAAAAHkCraLngqQvNxpJ31dsVuFsapft',
          badge: 'bottomright',
          size: 'invisible',
        });
        grecaptcha.execute(clientId, { action: 'registration' }).then((token) => {
          self.inputs.forEach((item) => {
            item
              .closest('form')
              .insertAdjacentHTML('beforeend', `<input name="iai-recaptcha-token" value="${token}" type="hidden">`);
          });
        });
      });
    };
    recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
    document.head.appendChild(recaptchaScript);
  }

  setEventsInput() {
    $(document).on('focus', this.inputClass, () => {
      this.prepareCaptcha();
      this.isApplied = true;
    });
  }
}
